import axios from 'axios';

import { PROBLEM_REPORT_UPLOAD_URL } from '../../../config/apiPaths';
import { getUrls } from '../../../utils/url';
import { type ProblemType } from '../types';

// Copied from /functions/problem-report/problem-report-upload-url
export type Parameters = {
    case_id?: string;
    contact?: string;
    debug_uuid?: string;
    description?: string;
    problem_type?: ProblemType;
    class_id?: string;
    session_id?: string;
    participant_id?: string;
};

// Copied from functions/problem-report/problem-report-upload-url
export type ResponseBody = {
    url: string;
    bucket: string;
    key: string;
    fileName: string;
};

export const reportProblemRequest = async (token: string | undefined, cfzAppVersion: string, body: Parameters) => {
    const { api } = getUrls();

    const response = await axios.post<ResponseBody>(`${api}${PROBLEM_REPORT_UPLOAD_URL}`, body, {
        headers: {
            Authorization: `Bearer ${token}`,
            'X-Cfz-App-Version': cfzAppVersion
        }
    });

    if (response.status !== 200) {
        throw new Error(JSON.stringify(response.data));
    }

    return response;
};
